import classNames from "classnames/bind";
import { OffStatus, OnStatus, SettingIcon } from "../../../../../components/Icons/Icons";
import styles from "./ModalListCamera.module.css";

const cx = classNames.bind(styles);

function TableListCamera({ dataCamera, handleSetting, showModalMore }) {
    const dataService = [
        'Chuyển động',
        'Nhận diện mặt'
    ]
    return (
        <>
            <table className={cx('table')}>
                <thead>
                    <tr>
                        <th>STT</th>
                        <th>Tên Camera</th>
                        <th>
                            Thời gian bắt đầu hoạt động
                        </th>
                        <th>Thời gian kết thúc hoạt động</th>
                        <th>
                            Trạng thái
                        </th>
                        <th>
                            Thời gian bắt đầu
                        </th>
                        <th> Thời gian kết thúc</th>
                    </tr>
                </thead>
                <tbody>
                    {dataCamera && dataCamera.map((item) => {
                        return (
                            <tr key={item?.stt}>
                                <td>{item?.stt}</td>
                                <td>
                                    <div className={cx('name-camera')}>
                                        <span className={cx('name')}>{item.cameraName}</span>
                                    </div>
                                </td>
                                <td>{item?.timeStartApply}</td>
                                <td>{item?.timeEndApply}</td>
                                <td>Đang hoạt động</td>
                                <td>{item?.timeStart}</td>
                                <td>{item?.timeEnd}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </>
    )
}

export default TableListCamera;